import { ButtonDropdown } from "./Elements/ButtonDropdown";
import { ChipDropdown } from "./Elements/ChipDropdown";
import { InputDropdown } from "./Elements/InputDropdown";

/**
 * @param {Object} props
 * @param {String} id Dropdown id
 * @param {Boolean} open
 * @param {String} type Dropdown type (input, button)
 * @param {String} label Dropdown Input label
 * @param {String} value Dropdown Input value
 * @param {Object} inputProps Dropdown Input Component props
 * @param {String} buttonText Dropdown Button text
 * @param {Object} buttonProps Dropdown Button Component props
 * @param {Function} onClick Function executed on click
 * @param {Element} children Dropdown Component children
 */
export const Dropdown = ({ id, open, type, label, value, togglerProps, buttonText, onClick, children, ...props }) => {
  let DropdownComponent;
  let dropdownProps;
  switch (type) {
    case "input":
      DropdownComponent = InputDropdown;
      dropdownProps = {
        label,
        value,
      };
      break;

    case "button":
      DropdownComponent = ButtonDropdown;
      dropdownProps = {
        buttonText,
        togglerProps,
      };
      break;
    case "chip":
      DropdownComponent = ChipDropdown;
      dropdownProps = {
        label,
        togglerProps,
      };
      break;
  }

  return (
    <DropdownComponent id={id} open={open} onClick={onClick} {...dropdownProps} {...props}>
      {children}
    </DropdownComponent>
  );
};
